<div class="bmc-waits">
  <h5 class="bmc-waits__description bz-space--stack-l">{{'WAITS.DESCRIPTION' | translate}}</h5>
  <bzg-tab-set class="bmc-waits__container" (onSelectTab)="selectedTab = $event.index">
    <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'WAITS.WAITINGS_JOBS' | translate | uppercase}}">
      <jobs-table [jobType]="jobType" [jobState]="jobStates.Waiting" [title]="'WAITS.NO_WAITS_TITLE'" [subtitle]="'WAITS.NO_WAITS_SUBTITLE'">
      </jobs-table>
    </bzg-tab-item>
    <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'WAITS.EXECUTED_JOBS' | translate | uppercase}}">
      <jobs-table [jobType]="jobType" [jobState]="jobStates.Executed" [title]="'WAITS.NO_WAITS_TITLE'" [subtitle]="'WAITS.NO_WAITS_SUBTITLE'">
      </jobs-table>
    </bzg-tab-item>
  </bzg-tab-set>
</div>
